<div class="container">
    <p-dropdown
        class="{{ gClass }}"
        [options]="options"
        [formControl]="formControl"
        [showClear]="clearButton"
        placeholder="{{ placeholder }}"
        optionValue="{{ value }}"
        optionLabel="{{ label }}"
        (onChange)="onChange($event)"
    >
    </p-dropdown>
</div>
